import { useEffect } from 'react';
import styled from 'styled-components';

import FieldWithErrorDisplay from "./FieldWithErrorDisplay"
import { Formik, Form, useFormikContext } from 'formik';
import { cloneDeep } from "lodash";

import ProdCompanyInput from "./ProdCompanyInput";
import DepartmentsInput from "./DepartmentsInput"

import CSVReader from "./Utility/CSVReader";
import ImageUploader from "./Utility/ImageUploader";

const FormContainer = styled.div`
  overflow-y: scroll;
  padding: 0 2em;
  height: 100vh;
`
const FieldGroupContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
`;

const LabelWithUpload = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const newProdCompany = {
  name: "Production Company 1",
  address1: "",
  address2: "",
  city: "",
  stateProv: "",
  zipCode: ""
}

const newMember = {
  title: "Department Role 1",
  name: "Department Member Name",
  phone: "",
  email: ""
}

const newDepartment = {
  name: "Department 1",
  members: [cloneDeep(newMember)]
}

const initialValues = {
    projectName: "",
    prodCompanies: [cloneDeep(newProdCompany)],
    departments: [cloneDeep(newDepartment)],
    uploadedImage: null
}

const Logger = (props) => {
  const formik = useFormikContext();

  useEffect(() => {
    props.valuesSetter(formik.values)
  }, [formik.values, props])
}

const StaffSheetForm = (props) => {
  return (
    <FormContainer>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) => {
          await new Promise((r) => setTimeout(r, 500));
          alert(JSON.stringify(values, null, 2));
        }}
      >
        {({ values, setFieldValue }) => {
          return(
            <Form onChange={props.changed}>
              <Logger valuesSetter={props.valuesSet}/>
              <div>
                <h1>{values.projectName.length > 0 ? `${values.projectName} Staff List` : `Untitled Staff List`}</h1>
              </div>
              <FieldGroupContainer>
                <FieldWithErrorDisplay
                  labelFor="projectName"
                  label="Project Name"
                  type="text"
                />
                <ImageUploader
                  setField={setFieldValue}
                />
              </FieldGroupContainer>
              <h3>Production Compan{values.prodCompanies.length > 1 ? "ies" : "y"}</h3>
              <ProdCompanyInput
                companies={values.prodCompanies}
                setField={setFieldValue}
              />
              <LabelWithUpload>
                <div>
                  <h3>Departments</h3>
                </div>
                <div><CSVReader setField={setFieldValue}/></div>
              </LabelWithUpload>
              <DepartmentsInput
                departments={values.departments}
                setField={setFieldValue}
              />
            </Form>
        )}}
      </Formik>
    </FormContainer>
  )
}

export default StaffSheetForm;
